module.exports = __webpack_public_path__ + "media/img/auth/campus-cap-mask-1f1b7b3db260aaa71b364e75571f9d34.svg";